import PhoneNumberRevealAction from './PhoneNumberRevealAction';
export default PhoneNumberRevealAction;